import { render, staticRenderFns } from "./Blocklist.vue?vue&type=template&id=7c31d168&"
import script from "./Blocklist.vue?vue&type=script&lang=js&"
export * from "./Blocklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports